<template>
  <article id="ingredients-article">
    <p class="title">Ingrédients non validés</p>

    <div v-if="ingredients.length">
      <Ingredient
        class="ingredient"
        v-for="(ingredient, index) in ingredients"
        :key="ingredient.ref.id"
        :ingredient="ingredient"
        @remove="() => removeAnimation(index)"
      />
    </div>
    <div v-else>
      <p>Aucun ingrédient non validé</p>
    </div>
  </article>
</template>

<script>
import ingredientsService from '../../../services/ingredients.service';
import Ingredient from './Ingredient.vue';

export default {
  components: {
    Ingredient,
  },
  data() {
    return {
      ingredients: [],
    };
  },
  async created() {
    this.ingredients = await ingredientsService.getNonValidatedIngredients();
  },
  methods: {
    removeAnimation(index) {
      this.ingredients[index].remove = true;
      const it = this;
      setTimeout(() => {
        it.ingredients.splice(index, 1);
      }, 0);
    },
  },
};
</script>

<style lang="scss" scoped src="./Ingredients.scss"></style>
